<template>
  <Layout
    :errors="errors"
    :title="trans(`models.${resourceType}.content.index.title`)"
    :toasts="toasts"
    :resource="models"
  >
    <div class="row px-4">
      <div v-for="(model) in models.data" class="col-6 col-md-3 px-2 py-0">
        <Link :href="route(`${routePrefix}.video-categories.show`, { video_category: model.data.id })" class="card category-card">
          <img :src="model.data.attributes.image_url" />
          <div class="card-title">
            {{ model.data.attributes.title }}
          </div>
        </Link>
      </div>
    </div>
  </Layout>
</template>

<script>
import FooterContent from '@/structures/moviary/components/Custom/FooterContent';
import HeaderContent from '@/structures/moviary/components/Custom/HeaderContent';
import Layout from '@/structures/moviary/Pages/Layout';
import Pagination from '@/structures/default/components/Pagination';
import ResourceActionButtons from '@/structures/default/components/Links/ResourceActionButtons';
import ResourceList from '@/structures/default/components/Collection/ResourceList';
import { Link } from '@inertiajs/vue3';
import useCustomActionBox from '@/structures/default/composables/useCustomActionBox';
import usePagination from '@/structures/default/composables/usePagination';
import useResourceParams from '@/structures/default/composables/useResourceParams';
import useToasts from '@/structures/default/composables/useToasts';

export default {
  components: {
    FooterContent,
    HeaderContent,
    Layout,
    Link,
    Pagination,
    ResourceActionButtons,
    ResourceList,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    models: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
    meta: { type: Object, default: () => {} },
    resourceType: { type: String, default: '' },
    config: { type: Object, default: () => {} },
    sort: { type: String, default: 'id' },
    filter: { type: Object, default: () => {} },
    excludeNull: { type: Object, default: () => {} },
    customActionData: { type: Object, default: () => {} },
  },
  setup(props) {
    const { customActionBox } = useCustomActionBox(props);
    const { addToast } = useToasts(props);
    const { getIndexParams } = useResourceParams(props);
    const { updatePerPage } = usePagination();

    const hasDescription = (trans) => {
      let transString = `models.${props.resourceType}.content.index.description`;
      let translation = trans(transString);

      return translation && translation !== transString;
    };

    return {
      addToast,
      customActionBox,
      getIndexParams,
      hasDescription,
      updatePerPage,
    };
  },
};
</script>
